import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { PermissionService, AppModule } from '../services/permission.service';

/**
 * PermissionGuard — blocks navigation to a route if the user lacks view access.
 *
 * Usage in routing:
 *   { path: 'payments', canActivate: [AuthGuard, PermissionGuard], data: { module: 'payments' }, ... }
 *
 * NOTE: This is a UX guard only. The PHP API enforces real access control.
 */
@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {

    constructor(
        private permissionService: PermissionService,
        private router: Router,
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const module = route.data?.['module'] as AppModule | undefined;

        // No module specified → allow (dashboard, misc pages)
        if (!module) return true;

        if (this.permissionService.isAllowed(module, 'view')) return true;

        this.router.navigate(['/dashboard']);
        return false;
    }
}
